import { Droplets } from "lucide-react";

const items = [
    "Pressure Washing",
    "Window Cleaning",
    "Driveways",
    "House Washing",
    "Deck & Patio",
    "Commercial Cleaning",
    "Soft Wash",
    "Gutter Cleaning",
];

export default function Marquee() {
    const list = [...items, ...items];
    return (
        <section
            data-testid="marquee-section"
            className="border-y border-white/10 bg-[#1E88E5] py-5 overflow-hidden"
        >
            <div className="flex marquee-track whitespace-nowrap">
                {list.map((it, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-6 px-8 text-white font-display font-bold uppercase text-xl tracking-tight"
                    >
                        <span>{it}</span>
                        <Droplets className="w-5 h-5 opacity-80" />
                    </div>
                ))}
            </div>
        </section>
    );
}
